<template>
  <div
    :class="disclosureOpened ? 'shadow-cards_hover' : ''"
    class="h-fit flex flex-col flex-1 border border-grays-400 bg-white rounded hover:shadow-cards_hover"
  >
    <div class="w-full h-fit flex flex-col pt-[20px] pb-[11px] px-[20px]">
      <div class="w-full flex flex-row items-center mb-[20px]">
        <div
          class="h-[36px] w-[36px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[9px]"
        >
          <icon-mishnat></icon-mishnat>
        </div>
        <div class="w-full flex flex-col">
          <h2 class="font-bold text-xl text-complementary-900">
            {{ $saleName(upcomingSale) }}
          </h2>
          <p class="font-regular text-sm text-complementary-900 mt-[-5px]">
            המכירה השבועית
          </p>
        </div>
      </div>
      <div class="w-full flex flex-col">
        <p class="font-medium text-sm text-grays-600 mb-[8px]">פתיחת המכירה</p>
        <div class="flex flex-row items-center gap-[4px]">
          <span
            class="material-symbols-rounded text-grays-900 text-[16px] leading-[16px] flex"
            >schedule</span
          >
          <p class="text-base font-regular text-grays-900">
            {{ moment(upcomingSale.supply_begin).format("dddd") }}
            {{ jDate(upcomingSale.supply_begin) }}
            {{ moment(upcomingSale.supply_begin).format("DD/MM/Y") }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="flex flex-col max-h-[226px] custom-scroll-bar overflow-y-auto border-t border-grays-400"
    >
      <Disclosure v-slot="{ open }" as="div">
        <div class="w-ful flex flex-col px-[20px]">
          <DisclosureButton
            class="flex flex-row-reverse items-center justify-between gap-[8px] py-[16px]"
            @click="triggerDisclosure"
          >
            <button
              class="group w-7 h-7 rounded-md flex flex-none justify-center items-center bg-primary-400 hover:bg-primary-100 focus:bg-purple_semantic active:bg-purple_semantic disabled:bg-grays-400"
            >
              <span
                :class="open ? 'rotate-180' : ''"
                class="material-symbols-rounded text-xl text-primary-700 group-disabled:text-grays-600"
                >expand_more</span
              >
            </button>
            <p class="text-lg text-primary-700 font-medium">קטגוריות במכירה</p>
          </DisclosureButton>
          <DisclosurePanel class="pb-[27px]">
            <categories-menu-view :categoriesList="upcomingSale.categories" />
          </DisclosurePanel>
        </div>
      </Disclosure>
    </div>
  </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import moment from "moment";
import "moment/dist/locale/he";

import dayjs from "dayjs";
import "dayjs/locale/he";

import hebrewDate from "hebrew-date";

export default {
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
  },
  name: "card-coming-sale",
  props: {
    upcomingSale: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disclosureOpened: false,
    };
  },
  methods: {
    triggerDisclosure() {
      this.disclosureOpened = !this.disclosureOpened;
      if (this.disclosureOpened) {
        this.$gtag?.event("sale_categories_open", { sale_status: "upcoming" });
      }
      this.$nextTick(() => {
        const pageHeight = document.documentElement.scrollHeight;
        window.scrollTo({ top: pageHeight, left: 0, behavior: "smooth" });
      });
    },
    moment: function (param1, param2) {
      return moment(param1, param2);
    },

    jDate: function (date) {
      const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
      ];
      const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
      ];
      const years = {
        5781: "תשפ״א",
        5783: "תשפ״ג",
        5782: "תשפ״ב",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
      };
      const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
      // @ts-ignore
      const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
      const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));
      // const day = dayjs(date, "YYYY-MM-DD").locale('he').format("dddd");
      // @ts-ignore
      return (
        days[hebrewDate(new Date(y, m, d)).date - 1] +
        " " +
        months[hebrewDate(new Date(y, m, d)).month - 1]
      );
    },
  },
};
</script>

<style>
</style>